import { useMemo } from 'react';
export function useFreeze(inValue) {
    var freezed = useMemo(function () { return inValue; }, []);
    return freezed;
}
